export default {"src":"/_next/static/media/bike_64.af6c7465.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};